$(function() {

  let $relationSlide1 = $('.js-relationSlide');

  // 記事詳細 関連記事スライド
  if ($relationSlide1.length) {

    // $relationSlide1 複数ある場合
    $.each($relationSlide1, function(index, elem) {

      let childerenLength = $(elem).children().length;
      // console.log(childerenLength);

      // SPのときSlideの子要素が2つ以上の場合か、Slideの子要素が3つ以上のとき
      if ((($('html').hasClass('-sp') || $('html').hasClass('-tb')) && childerenLength > 1) || childerenLength > 3) {
        relationSlide($(elem));
        // 要素が少なく、スライダーにしないとき
      } else {
        $(elem).addClass('-noSlide');
      }
    });

  }


  function relationSlide($sliderTarget) {

    console.log('relationSlides');

    $sliderTarget.slick({
      arrows: true,
      centerMode: false,
      slidesToShow: 3,
      dots: false,
      // infinite: true,
      infinite: false,
      slidesToScroll: 1,
      autoplay: false,
      centerPadding: 0,
      responsive: [{
        breakpoint: 769,
        settings: {
          arrows: false,
          dots: true,
          centerMode: true,
          slidesToShow: 1,
          infinite: false,
          centerPadding: '8.8%', // 23 + 43 / 750
        }
      }]
    });

  }

});
